export default __webpack_public_path__ + "static/media/ornek_toplu_meslek_kodu_guncelle.c5354a74.xlsx";